/* Ott-common */
import { createForgeRockService } from "ott-common/dist/forgeRockService";

/* Others */
import { getSsoToken } from "../state/localStorage";
import { forgeRockAuthString, isBrazil, SERVICES_CLIENT_ID } from "../utils";

export default createForgeRockService({
  apiToken: forgeRockAuthString,
  getIsBrazil: () => isBrazil,
  getSsoToken: () => getSsoToken(),
  host: process.env.REACT_APP_FORGE_ROCK_BASE_PATH,
  clientId: SERVICES_CLIENT_ID
});
